import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs";
import { PlanCategoriesRoute } from "../../routing/IndividualRoutes";

export class PlanCategoriesPage extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumbs />
        <PlanCategoriesRoute />
      </Fragment>
    );
  }
}
